/**
 * Pantalla provisional — misma envoltura visual que el resto del sistema (PageHeader + contenido).
 * Se usa automáticamente cuando una pestaña del registro no tiene `component` asignado.
 * Para activar la pantalla real: en modulo_visor.js / modulo_laboral.js agregue
 *   component: <MiPantalla />
 * en la entrada createModuloTab correspondiente.
 */
import { PageHeader } from "@/pages/layoutChrome";
import { Construction } from "lucide-react";
import { moduleContextLabel, getStoredWorkModule } from "@/modules/workModuleCore";

export default function ModuloPlaceholder({
  title,
  subtitle,
  breadcrumbModule,
}) {
  const moduleLabel = moduleContextLabel(getStoredWorkModule());

  return (
    <>
      <PageHeader
        title={title}
        subtitle={subtitle || `Módulo activo: ${moduleLabel}. Contenido en preparación — la pestaña ya está integrada al menú.`}
        breadcrumb={[
          moduleLabel,
          ...(breadcrumbModule && breadcrumbModule !== moduleLabel ? [breadcrumbModule] : []),
          title,
        ]}
      />
      <div className="p-8 max-w-2xl mx-auto">
        <div className="rounded-sm border border-dashed border-slate-300 bg-white p-8 text-center space-y-3">
          <Construction className="w-10 h-10 mx-auto text-slate-300" aria-hidden />
          <p className="text-sm font-medium text-slate-700">{title}</p>
          <p className="text-sm text-slate-600">
            Esta pestaña ya forma parte del módulo <strong>{moduleLabel}</strong>.
            La funcionalidad se cargará aquí sin cambiar la navegación ni el sidebar.
          </p>
        </div>
      </div>
    </>
  );
}
